/* eslint-disable @typescript-eslint/no-explicit-any */
import { gridBreakpoints, downGridBreakpoints } from './variables';

type GridBreakpoints = typeof gridBreakpoints;
type MediaBreakpointUp = {
  [key in keyof GridBreakpoints]: any;
};

export const mediaBreakpointUp = Object.keys(gridBreakpoints).reduce(
  (accumulator, label) => {
    accumulator[label] = `@media (min-width: ${gridBreakpoints[label]})`;

    return accumulator;
  },
  {},
) as MediaBreakpointUp;

type DownMediaBreakpoints = typeof downGridBreakpoints;
type MediaBreakpointDown = {
  [key in keyof DownMediaBreakpoints]: any;
};

export const mediaBreakpointDown = Object.keys(downGridBreakpoints).reduce(
  (accumulator, label) => {
    accumulator[label] = `@media (max-width: ${downGridBreakpoints[label]})`;

    return accumulator;
  },
  {},
) as MediaBreakpointDown;

export const mediaAppMobile = mediaBreakpointDown.sm;
